import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Dropdown} from 'primereact/dropdown';
import {MultiSelect} from 'primereact/multiselect';
import {Checkbox} from 'primereact/checkbox';
import {Button} from 'primereact/button';
import {AutoComplete} from 'primereact/autocomplete';
import {ProgressSpinner} from 'primereact/progressspinner';
import './styles.css';


class AnaliseTemporalExportForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,

            // Projeto
            projeto: null,

            // Período
            periodoInicial: null,
            periodoFinal: null,

            // Agrupamento
            tipoAgrupamento: 'mensal',

            // Localização
            estados: [],
            cidadesOptions: [],
            cidades: [],

            // Filtros
            formato: 'Colunas',
            tipos: [],
            padroes: [],
            anosLancamento: [],
            clusters: [],
            clustersOptions: [],

            // Incorporadora
            incorporadoraQuery: '',
            incorporadorasSuggestions: [],
            incorporadoras: [],

            // Empreendimento
            empreendimentoQuery: '',
            empreendimentosSuggestions: [],
            empreendimentos: [],

            // Opções
            nacional: false,
            esgotado: false,
            areasLazer: false,

            // Errors / feedback
            errors: {},
            successMessage: null,
            errorMessage: null,
        };
    }

    get projetosOptions() {
        return [...this.props.projetos];
    }

    get estadosOptions() {
        return this.props.estados.map(e => ({ label: e.nome, value: e.sigla }));
    }

    get tiposAgrupamentoOptions() {
        return [
            { label: 'Mensal', value: 'mensal' },
            { label: 'Trimestral', value: 'trimestre' },
            { label: 'Semestral', value: 'semestre' },
            { label: 'Anual', value: 'anual' },
        ];
    }

    get formatoOptions() {
        return [
            { label: 'Colunas', value: 'Colunas' },
            { label: 'Linhas', value: 'Linhas' },
        ];
    }

    get tiposOptions() {
        return [
            { label: 'Comercial', value: 'Comercial' },
            { label: 'Horizontal', value: 'Horizontal' },
            { label: 'Vertical', value: 'Vertical' },
        ];
    }

    get padroesOptions() {
        return this.props.padroes.map(p => ({ label: p, value: p }));
    }

    get anosLancamentoOptions() {
        return this.props.anosLancamento.map(a => ({ label: String(a), value: String(a) }));
    }

    loadCidades = async (siglas) => {
        if (!siglas || siglas.length === 0) {
            this.setState({ cidadesOptions: [], cidades: [], clustersOptions: [], clusters: [] });
            return;
        }
        try {
            const response = await fetch(`/cidades_options/${siglas.join(',')}`);
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const options = [];
            doc.querySelectorAll('optgroup').forEach(group => {
                const groupLabel = group.getAttribute('label');
                group.querySelectorAll('option').forEach(opt => {
                    if (opt.value) {
                        options.push({ label: opt.textContent.trim(), value: opt.value, group: groupLabel });
                    }
                });
            });
            if (options.length === 0) {
                doc.querySelectorAll('option').forEach(opt => {
                    if (opt.value) {
                        options.push({ label: opt.textContent.trim(), value: opt.value });
                    }
                });
            }
            this.setState({ cidadesOptions: options, cidades: [], clustersOptions: [], clusters: [] });
        } catch (e) {
            console.error('Erro ao carregar cidades:', e);
        }
    };

    loadClusters = async (cidadeIds) => {
        if (!cidadeIds || cidadeIds.length === 0) {
            this.setState({ clustersOptions: [], clusters: [] });
            return;
        }
        try {
            const response = await fetch(`/clusters_options/${cidadeIds.join(',')}`);
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const options = [];
            doc.querySelectorAll('option').forEach(opt => {
                if (opt.value) {
                    options.push({ label: opt.textContent.trim(), value: opt.value });
                }
            });
            this.setState({ clustersOptions: options, clusters: [] });
        } catch (e) {
            console.error('Erro ao carregar clusters:', e);
        }
    };

    searchIncorporadoras = async (event) => {
        try {
            const response = await axios.get('/auto-complete/incorporadoras', { params: { search: event.query } });
            const mapped = response.data.map(i => ({ label: i.text, value: i.id }));
            this.setState({
                incorporadorasSuggestions: mapped.length > 0
                    ? [{ label: 'Selecionar todos', value: '__select_all__' }, ...mapped]
                    : [],
            });
        } catch (e) {
            this.setState({ incorporadorasSuggestions: [] });
        }
    };

    handleIncorporadorasChange = (e) => {
        const values = e.value;
        if (values.some(v => v.value === '__select_all__')) {
            const real = this.state.incorporadorasSuggestions.filter(s => s.value !== '__select_all__');
            const existing = this.state.incorporadoras;
            const merged = [...existing];
            real.forEach(s => {
                if (!merged.some(m => m.value === s.value)) merged.push(s);
            });
            this.setState({ incorporadoras: merged });
        } else {
            this.setState({ incorporadoras: values });
        }
    };

    searchEmpreendimentos = async (event) => {
        const cidadeIds = this.state.cidades.map(c => c.value || c);
        const params = { search: event.query };
        const url = cidadeIds.length > 0
            ? route('autocomplete-building-names', { id: cidadeIds.join(',') })
            : route('autocomplete-building-names');
        try {
            const response = await axios.get(url, { params });
            const suggestions = response.data || [];
            const mapped = suggestions
                .filter(e => e.id !== 'Selecionar Todos')
                .map(e => ({
                    label: e.text,
                    value: e.id ?? e.text,
                }));
            this.setState({
                empreendimentosSuggestions: mapped.length > 0
                    ? [{ label: 'Selecionar todos', value: '__select_all__' }, ...mapped]
                    : [],
            });
        } catch (e) {
            this.setState({ empreendimentosSuggestions: [] });
        }
    };

    handleEmpreendimentosChange = (e) => {
        const values = e.value;
        if (values.some(v => v.value === '__select_all__')) {
            const real = this.state.empreendimentosSuggestions.filter(s => s.value !== '__select_all__');
            const existing = this.state.empreendimentos;
            const merged = [...existing];
            real.forEach(s => {
                if (!merged.some(m => m.value === s.value)) merged.push(s);
            });
            this.setState({ empreendimentos: merged });
        } else {
            this.setState({ empreendimentos: values });
        }
    };

    loadProjeto = async (projetoId) => {
        if (!projetoId) return;
        try {
            const response = await fetch(`/mapa-state/${projetoId}`);
            const data = await response.json();
            if (!data || !data.project) return;

            const p = data.project;
            const newState = {};

            if (p.estado) {
                const siglas = JSON.parse(p.estado);
                newState.estados = siglas;
                await this.loadCidades(siglas);
            }

            if (p.cidade) {
                newState.cidadesPendentes = JSON.parse(p.cidade);
            }

            if (p.tipo_empreendimento) {
                newState.tipos = JSON.parse(p.tipo_empreendimento);
            }

            if (p.padrao) {
                const padroes = JSON.parse(p.padrao);
                newState.padroes = padroes.map(pad => pad.label ?? pad);
            }

            if (p.ano_lancamento) {
                const anos = JSON.parse(p.ano_lancamento);
                newState.anosLancamento = anos.map(a => String(a.label ?? a));
            }

            if (p.incorporadoras) {
                const incs = JSON.parse(p.incorporadoras);
                const incorporadoraItems = [];
                for (const inc of incs) {
                    try {
                        const res = await axios.get(`/incorporadoras-json-id/${inc.label}`);
                        incorporadoraItems.push({ label: inc.label, value: res.data });
                    } catch (e) {
                        console.error(`Erro ao carregar incorporadora ${inc.label}:`, e);
                    }
                }
                newState.incorporadoras = incorporadoraItems;
            }

            if (p.nome_empreendimento) {
                const nomes = JSON.parse(p.nome_empreendimento);
                newState.empreendimentos = nomes.map(n => ({ label: n, value: n }));
            }

            this.setState(newState, () => {
                if (newState.cidadesPendentes && this.state.cidadesOptions.length > 0) {
                    const matches = this.state.cidadesOptions.filter(opt =>
                        newState.cidadesPendentes.some(c => c.label === opt.label)
                    );
                    this.setState({ cidades: matches.map(c => c.value) });
                }
            });
        } catch (e) {
            console.error('Erro ao buscar projeto:', e);
        }
    };

    validate = () => {
        const { periodoInicial, periodoFinal, cidades, nacional } = this.state;
        const errors = {};
        if (!periodoInicial) errors.periodoInicial = 'Campo requerido';
        if (!periodoFinal) errors.periodoFinal = 'Campo requerido';
        if (!nacional && cidades.length === 0) errors.cidades = 'Selecione ao menos uma cidade';
        return errors;
    };

    formatMonth = (date) => date || '';

    handleSubmit = async (e) => {
        e.preventDefault();
        const errors = this.validate();
        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }

        this.setState({ loading: true, errors: {}, successMessage: null, errorMessage: null });

        const {
            periodoInicial, periodoFinal, tipoAgrupamento, estados, cidades,
            formato, tipos, padroes, anosLancamento, clusters,
            incorporadoras, empreendimentos, nacional, esgotado, areasLazer,
        } = this.state;

        const params = new URLSearchParams();
        params.append('period_inicial', this.formatMonth(periodoInicial));
        params.append('period_final', this.formatMonth(periodoFinal));
        params.append('tipo_agrupamento', tipoAgrupamento);
        params.append('formato', formato);
        if (nacional) params.append('nacional', 'true');
        if (esgotado) params.append('esgotado', 'Esgotado');
        if (areasLazer) params.append('areas_lazer', 'true');

        estados.forEach(s => params.append('estado[]', s));
        cidades.forEach(c => params.append('cidade[]', c));
        tipos.forEach(t => params.append('tipo[]', t));
        padroes.forEach(p => params.append('padroes[]', p));
        anosLancamento.forEach(a => params.append('ano_lancamento[]', a));
        clusters.forEach(c => params.append('cluster[]', c));
        incorporadoras.forEach(i => params.append('search_incorporadora[]', i.value));
        empreendimentos.forEach(em => params.append('nome[]', em.value));

        try {
            const { data } = await axios.post(route('analise_temporal.excel'), params, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            });
            this.setState({ successMessage: data.message, loading: false });
            window.dispatchEvent(new CustomEvent('analise-export-created'));
        } catch (err) {
            const status = err.response?.status;
            if (status === 422) {
                const body = err.response.data;
                const serverErrors = body.errors
                    ? Object.fromEntries(Object.entries(body.errors).map(([k, v]) => [k, Array.isArray(v) ? v[0] : v]))
                    : {};
                this.setState({ errors: serverErrors, errorMessage: body.message || null, loading: false });
            } else {
                this.setState({ errorMessage: 'Erro ao enviar solicitação. Tente novamente.', loading: false });
            }
        }
    };

    renderField(label, required, children, error) {
        return (
            <div style={{ marginBottom: '12px' }}>
                <label className="at-export-label" style={{ display: 'block' }}>
                    {label}
                </label>
                {children}
                {error && (
                    <small style={{ color: '#e53935', fontSize: '11px', marginTop: '3px', display: 'block' }}>
                        {error}
                    </small>
                )}
            </div>
        );
    }

    render() {
        const {
            loading, projeto, periodoInicial, periodoFinal, tipoAgrupamento,
            estados, cidadesOptions, cidades, formato, tipos, padroes,
            anosLancamento, clustersOptions, clusters, incorporadoras, incorporadorasSuggestions,
            empreendimentos, empreendimentosSuggestions, nacional, esgotado, areasLazer,
            errors, successMessage, errorMessage,
        } = this.state;

        const { canExportarNacional, isCliente } = this.props;

        return (
            <div className="position-relative">
                {loading && (
                    <div style={{
                        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                        background: 'rgba(255,255,255,0.7)', zIndex: 1000,
                        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                        backdropFilter: 'blur(2px)',
                    }}>
                        <ProgressSpinner style={{ width: '48px', height: '48px' }} />
                        <p style={{ marginTop: '12px', color: '#495057', fontWeight: 500, fontSize: '14px' }}>
                            Gerando relatório…
                        </p>
                    </div>
                )}

                {/* Aviso */}
                <div style={{
                    display: 'flex', alignItems: 'center', gap: '1px',
                    marginBottom: '20px',
                }}>
                    <p className="exec-info">
                        <img src="/img/icons/63.png" alt="Aviso" style={{ width: '20px', height: '20px' }} /> &nbsp;
                        Para otimizar o tempo de carregamento, o relatório permite a seleção de, no máximo, 24 períodos por vez.
                    </p>
                </div>

                {/* Feedback */}
                {successMessage && (
                    <div style={{
                        display: 'flex', alignItems: 'flex-start', gap: '10px',
                        background: '#e8f5e9', border: '1px solid #a5d6a7', borderRadius: '4px',
                        padding: '12px 16px', marginBottom: '16px',
                    }}>
                        <i className="fa fa-check-circle" style={{ fontSize: '16px', color: '#43a047', marginTop: '1px', flexShrink: 0 }} />
                        <div style={{ flex: 1 }}>
                            <span style={{ fontSize: '13px', color: '#2e7d32' }}>{successMessage}</span>
                        </div>
                        <button
                            type="button"
                            onClick={() => this.setState({ successMessage: null })}
                            style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#43a047', padding: 0, fontSize: '14px' }}
                        >
                            <i className="fa fa-times" />
                        </button>
                    </div>
                )}
                {errorMessage && (
                    <div style={{
                        display: 'flex', alignItems: 'flex-start', gap: '10px',
                        background: '#ffebee', border: '1px solid #ef9a9a', borderRadius: '4px',
                        padding: '12px 16px', marginBottom: '16px',
                    }}>
                        <i className="fa fa-times-circle" style={{ fontSize: '16px', color: '#e53935', marginTop: '1px', flexShrink: 0 }} />
                        <div style={{ flex: 1 }}>
                            <span style={{ fontSize: '13px', color: '#c62828' }}>{errorMessage}</span>
                        </div>
                        <button
                            type="button"
                            onClick={() => this.setState({ errorMessage: null })}
                            style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#e53935', padding: 0, fontSize: '14px' }}
                        >
                            <i className="fa fa-times" />
                        </button>
                    </div>
                )}

                <form onSubmit={this.handleSubmit}>
                    {/* Row 1: Projeto */}
                    <div className="row">
                        <div className="col-sm-3">
                            {this.renderField('Projeto', false,
                                <Dropdown
                                    value={projeto}
                                    options={this.projetosOptions}
                                    onChange={e => { this.setState({ projeto: e.value }); this.loadProjeto(e.value); }}
                                    optionLabel="label"
                                    filter={true}
                                    optionValue="value"
                                    placeholder="Selecione"
                                    className="w-100"
                                />
                            )}
                        </div>
                    </div>

                    {/* Row 2: Período inicial, Período final, Estado, Cidade */}
                    <div className="row">
                        <div className="col-sm-3">
                            {this.renderField('Período inicial', true,
                                <input
                                    type="month"
                                    value={periodoInicial || ''}
                                    min="2010-01"
                                    max="2035-12"
                                    onChange={e => this.setState({ periodoInicial: e.target.value, errors: { ...errors, periodoInicial: null } })}
                                    className={`at-month-input w-100${errors.periodoInicial ? ' is-invalid' : ''}`}
                                />,
                                errors.periodoInicial
                            )}
                        </div>
                        <div className="col-sm-3">
                            {this.renderField('Período final', true,
                                <input
                                    type="month"
                                    value={periodoFinal || ''}
                                    min="2010-01"
                                    max="2035-12"
                                    onChange={e => this.setState({ periodoFinal: e.target.value, errors: { ...errors, periodoFinal: null } })}
                                    className={`at-month-input w-100${errors.periodoFinal ? ' is-invalid' : ''}`}
                                />,
                                errors.periodoFinal
                            )}
                        </div>
                        <div className="col-sm-3">
                            {this.renderField('Estado', false,
                                <MultiSelect
                                    value={estados}
                                    display="chip"
                                    options={this.estadosOptions}
                                    onChange={e => { this.setState({ estados: e.value }); this.loadCidades(e.value); }}
                                    filter
                                    placeholder="Selecione"
                                    className="w-100"
                                    disabled={nacional}
                                />
                            )}
                        </div>
                        <div className="col-sm-3">
                            {this.renderField('Cidade', false,
                                <MultiSelect
                                    value={cidades}
                                    options={cidadesOptions}
                                    display="chip"
                                    onChange={e => { this.setState({ cidades: e.value, errors: { ...errors, cidades: null } }); this.loadClusters(e.value); }}
                                    filter
                                    placeholder="Selecione"
                                    className={`w-100${errors.cidades ? ' p-invalid' : ''}`}
                                    disabled={nacional}
                                />,
                                errors.cidades
                            )}
                        </div>
                    </div>

                    {/* Row 3: Tipo de agrupamento, Formato, Tipo, Padrão */}
                    <div className="row">
                        <div className="col-sm-3">
                            {this.renderField('Tipo de agrupamento', false,
                                <Dropdown
                                    value={tipoAgrupamento}
                                    options={this.tiposAgrupamentoOptions}
                                    onChange={e => this.setState({ tipoAgrupamento: e.value })}
                                    placeholder="Selecione"
                                    className="w-100"
                                />
                            )}
                        </div>
                        <div className="col-sm-3">
                            {this.renderField('Formato', false,
                                <Dropdown
                                    value={formato}
                                    display="chip"
                                    options={this.formatoOptions}
                                    onChange={e => this.setState({ formato: e.value })}
                                    placeholder="Selecione"
                                    className="w-100"
                                />
                            )}
                        </div>
                        <div className="col-sm-3">
                            {this.renderField('Tipo', false,
                                <MultiSelect
                                    value={tipos}
                                    options={this.tiposOptions}
                                    onChange={e => this.setState({ tipos: e.value })}
                                    placeholder="Selecione"
                                    display="chip"
                                    className="w-100"
                                />
                            )}
                        </div>
                        <div className="col-sm-3">
                            {this.renderField('Padrão', false,
                                <MultiSelect
                                    value={padroes}
                                    options={this.padroesOptions}
                                    onChange={e => this.setState({ padroes: e.value })}
                                    filter
                                    display="chip"
                                    placeholder="Selecione"
                                    className="w-100"
                                />
                            )}
                        </div>
                    </div>

                    {/* Row 4: Incorporadora, Empreendimento, Ano de lançamento, Cluster */}
                    <div className="row">
                        <div className="col-sm-3">
                            {this.renderField('Incorporadora', false,
                                <AutoComplete
                                    value={incorporadoras}
                                    suggestions={incorporadorasSuggestions}
                                    completeMethod={this.searchIncorporadoras}
                                    field="label"
                                    multiple
                                    placeholder="Digite para buscar"
                                    onChange={this.handleIncorporadorasChange}
                                    className="w-100"
                                    inputClassName="w-100"
                                    style={{ width: '100%' }}
                                    minLength={3}
                                    itemTemplate={item => item.value === '__select_all__'
                                        ? <span style={{ fontWeight: 600, color: '#4D5A31' }}>{item.label}</span>
                                        : item.label
                                    }
                                />
                            )}
                        </div>
                        <div className="col-sm-3">
                            {this.renderField('Empreendimento', false,
                                <AutoComplete
                                    value={empreendimentos}
                                    suggestions={empreendimentosSuggestions}
                                    completeMethod={this.searchEmpreendimentos}
                                    field="label"
                                    multiple
                                    placeholder="Digite para buscar"
                                    onChange={this.handleEmpreendimentosChange}
                                    className="w-100"
                                    inputClassName="w-100"
                                    style={{ width: '100%' }}
                                    minLength={3}
                                    itemTemplate={item => item.value === '__select_all__'
                                        ? <span style={{ fontWeight: 600, color: '#4D5A31' }}>{item.label}</span>
                                        : item.label
                                    }
                                />
                            )}
                        </div>
                        <div className="col-sm-3">
                            {this.renderField('Ano de lançamento', false,
                                <MultiSelect
                                    value={anosLancamento}
                                    display="chip"
                                    options={this.anosLancamentoOptions}
                                    onChange={e => this.setState({ anosLancamento: e.value })}
                                    filter
                                    placeholder="Selecione"
                                    className="w-100"
                                />
                            )}
                        </div>
                        <div className="col-sm-3">
                            {this.renderField('Cluster', false,
                                <MultiSelect
                                    value={clusters}
                                    options={clustersOptions}
                                    onChange={e => this.setState({ clusters: e.value })}
                                    filter
                                    placeholder="Selecione"
                                    className="w-100"
                                    disabled={clustersOptions.length === 0}
                                />
                            )}
                        </div>
                    </div>

                    {/* Row 5: Checkboxes + FILTRAR button */}
                    <div className="row" style={{ marginTop: '8px' }}>
                        <div className="col-sm-8">
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', paddingTop: '4px' }}>
                                {canExportarNacional && (
                                    <label htmlFor="cb-nacional" className="ate-check-labels">
                                        <Checkbox
                                            inputId="cb-nacional"
                                            checked={nacional}
                                            onChange={e => this.setState({ nacional: e.checked, estados: e.checked ? [] : estados, cidades: e.checked ? [] : cidades })}
                                        />
                                        Todas as cidades
                                    </label>
                                )}
                                <label htmlFor="cb-esgotado" className="ate-check-labels">
                                    <Checkbox
                                        inputId="cb-esgotado"
                                        checked={esgotado}
                                        onChange={e => this.setState({ esgotado: e.checked })}
                                    />
                                    Adicionar esgotados
                                </label>
                                <label htmlFor="cb-areas-lazer"
                                       className="ate-check-labels">
                                    <Checkbox
                                        inputId="cb-areas-lazer"
                                        checked={areasLazer}
                                        onChange={e => this.setState({ areasLazer: e.checked })}
                                    />
                                    Adicionar áreas comuns
                                </label>
                            </div>
                        </div>
                        <div className="col-sm-4" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                            <Button
                                type="submit"
                                label="FILTRAR"
                                style={{
                                    fontFamily: '"Archivo Expanded", sans-serif',
                                    fontWeight: 600,
                                    fontSize: '25px',
                                    textTransform: 'uppercase',
                                    padding: '10px 18px',
                                    backgroundColor: '#B2B2B2',
                                    borderColor: '#B2B2B2',
                                    color: '#FFFFFF',
                                    height: '48px',
                                }}
                                disabled={loading}
                            />
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

const decodeHtmlEntities = (str) => {
    const txt = document.createElement('textarea');
    txt.innerHTML = str;
    return txt.value;
};

const el = document.getElementById('js-analise-temporal-export-form');
if (el) {
    const props = {
        projetos: JSON.parse(decodeHtmlEntities(el.dataset.projetos || '[]')),
        padroes: JSON.parse(decodeHtmlEntities(el.dataset.padroes || '[]')),
        anosLancamento: JSON.parse(decodeHtmlEntities(el.dataset.anosLancamento || '[]')),
        estados: JSON.parse(decodeHtmlEntities(el.dataset.estados || '[]')),
        canExportarNacional: el.dataset.canExportarNacional === 'true',
        isCliente: el.dataset.isCliente === 'true',
    };
    ReactDOM.render(<AnaliseTemporalExportForm {...props} />, el);
}
